















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component({
  name: 'SwitchWithLabel'
})
export default class SwitchWithLabel extends Vue {
  @Prop({ type: Boolean, default: false })
  value!: boolean;

  @Prop({ type: String, required: false })
  label!: string;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: String, default: 'small' })
  size!: 'small' | 'default';

  @Prop({ type: String, required: false })
  id?: string;

  @Prop({ type: String, required: false })
  title?: string;

  @Emit('input')
  handleChange(checked: boolean): boolean {
    return checked;
  }

  @Emit('change')
  emitChange(checked: boolean): boolean {
    return checked;
  }

  onSwitchChange(checked: boolean) {
    this.handleChange(checked);
    this.emitChange(checked);
  }
}
